import { Sheet } from "react-modal-sheet";
// import {AnimatePresence, motion} from "framer-motion/dist/framer-motion";

const ViewSummary = ({ children, showModal, onCloseModal, query }) => {
	return (
		<div>
			<Sheet isOpen={showModal} onClose={() => onCloseModal()} detent="content-height">
				<Sheet.Container
					className="sheet-con"
					style={{
						boxShadow: "0px -2px 4px rgba(0, 0, 0, 0.25)",
						borderRadius: "50px 50px 0px 0px"
					}}
				>
					<Sheet.Header>
						<div className="p-3 mt-2">
							<i
								className="fas fa-times closeIcon d-flex justify-content-end"
								onClick={() => onCloseModal()}
							></i>
							<div>
								<h3>Ticket Summary</h3>
							</div>
						</div>
					</Sheet.Header>
					<Sheet.Content>
						<div className="sheet-body mx-3">{children}</div>
					</Sheet.Content>
				</Sheet.Container>

				<Sheet.Backdrop />
			</Sheet>

			<style jsx>{`
				.closeIcon {
					color: #999999;
					font-size: 24px;
					position: absolute;
					right: 1.2em;
					cursor: pointer;
				}
				h3 {
					font-weight: 500;
					font-size: 24px;
					text-align: center;
					color: #212529;
				}
			`}</style>
		</div>
	);
};

export default ViewSummary;
